<div
  class="alert alert-{{ Size }} alert-bar type-{{ Type }}"
  role="alert"
  [class.middle]="middle"
  [class.d-none]="closeAlert">
  <span
    class="alert-title h3-bold"
    [ngClass]="{ 'justify-content-center text-center': !icon && !close }">
    @if (icon === true) {
      <app-ce-icon [name]="Icons"></app-ce-icon>
    }
    {{ label }}</span
  >
  @if (show_button) {
    <app-link-btn
      [label]="'Manage access'"
      [active]="false"
      [size]="'medium'"
      [IconType]="'chevron_right'"></app-link-btn>
  }
  @if (close === true) {
    <app-ce-icon
      [svg_class]="['close-alert', 'd-flex', 'cursor-pointer', 'primary-60']"
      aria-label="Close"
      (custom_click)="closealert()"
      [name]="'cancel'"></app-ce-icon>
  }
</div>
<ng-content></ng-content>
